import React from "react";
import Sidebar from "../components/chat/Sidebar";

// NOTE — the post-login Onboarding modal used to be triggered here.
// It has been moved to a dedicated /onboarding route that the login
// pages send the user to BEFORE the main app loads, via the helper
// in src/utils/postLoginRedirect.js. See src/pages/onboarding/OnboardingScreen.jsx
// for the wrapper that hosts the modal full-screen.
//
// Shell chrome — the fixed 72px left <Sidebar/> replaces the old TopToolbar,
// the Team/Admin/Exec FabStack and the back-to-chat FAB (all folded into the
// sidebar). On <=720px the same sidebar renders as the bottom icon bar, so
// the separate MobileBottomNav is no longer mounted here. Desktop margin-left
// (72px) / mobile bottom padding are handled by the .kwsb-content CSS the
// sidebar injects, so the responsive switch is pure CSS (no resize JS).
// The global KIRA float stays mounted app-wide via KiraGate — untouched.

export default function MessengerLayout({ children }) {
  return (
    <div className="min-h-screen bg-black text-white relative">
      <Sidebar />
      <main className="kwsb-content">
        {children}
      </main>
    </div>
  );
}
